<ion-header no-border mode="md">
  <ion-toolbar mode="md" title-with-slogan>
    <ion-title>
      <h2>
        <ion-text color="primary">
          {{ 'generic.valueConfig' | translate }}
        </ion-text>
      </h2>
      <p>{{ 'generic.boolean' | translate | uppercase }}</p>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="primary" (click)="dismiss()" mode="ios">
        <ion-icon class="bp-close" name="delete" ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">


  <div class="define-the-names">
    <h4>{{ 'configBoolean.instructions' | translate }}</h4>
    <ion-row llrm>
      <ion-col size="12" size-md="6">
        <ion-item>
          <ion-label position="stacked">
            {{ 'configBoolean.trueValue' | translate }}*
          </ion-label>
          <ion-input type="text"
            [(ngModel)]="config.possibleValuesGlobalized[language][0]"
            [placeholder]="'configBoolean.trueValue' | translate"
          ></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="12" size-md="6">
        <ion-item>
          <ion-label position="stacked">
            {{ 'configBoolean.falseValue' | translate }}*
          </ion-label>
          <ion-input type="text"
            [(ngModel)]="config.possibleValuesGlobalized[language][1]"
            [placeholder]="'configBoolean.falsePlaceholder' | translate"
          ></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
  </div>
</ion-content>

<ion-footer mode="ios">
  <ion-toolbar mode="ios">
    <ion-row>
      <ion-col hidden-mobile>
      </ion-col>
      <ion-col size-md="4">
        <ion-button color="secondary" expand="block" mode="ios"
          (click)="save()" >
          {{ 'generic.save' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>